export const USER_DATA = "userData";
export const GAME_STATE = "gameState";
export const SETTINGS = "settings";
